import { TechemBreadcrumb } from '@techem/ui-components';
import * as React from 'react';
import { Container } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { paths } from 'frameworks_drivers/routes';

import ReturnPolicyContent from './ReturnPolicyContent';

const ReturnPolicyPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container className="py-4 mb-5">
      <div className="my-4">
        <TechemBreadcrumb
          items={[
            {
              additionalTestId: 'home',
              href: `/#${paths.LandingPage}`,
              title: t('breadcrumbHome')
            }
          ]}
          currentPageTitle={t('breadcrumbReturnPolicy')}
        />
      </div>

      <h2
        className="text-start pe-4"
        style={{ fontSize: 40, lineHeight: '56px', marginBottom: 40 }}
      >
        <Trans i18nKey="breadcrumbReturnPolicy" />
      </h2>
      <ReturnPolicyContent />
    </Container>
  );
};

export default ReturnPolicyPage;
